<template>
  <v-button
    v-if="!isLoading && submissionsCount > 0"
    class="v-toolbar__button --reduced mr-1 toolbar-submissions-button"
    secondary
    ghost
    round
    @click="showFormSubmissions"
  >
    <span class="toolbar-submissions-button__count">
      {{ submissionsCount }}
    </span>
    <v-icon icon="bar_chart" />

    <form-submissions-modal
      :header="
        $t('components.toolbar.submissionsButton.resultTitle', { title: title })
      "
      :form-id="formId"
      :is-missable="isMissable"
    />
  </v-button>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import FormSubmissionsModal, {
  FORM_SUBMISSIONS_HASH
} from "@/components/modals/FormSubmissionsModal"

export default {
  components: {
    FormSubmissionsModal
  },

  props: {
    title: { type: String, required: true },
    formId: { type: Number, required: true },
    isMissable: { type: Boolean, default: false }
  },

  data() {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("forms", ["formSubmissionsCount"]),

    submissionsCount() {
      return this.formSubmissionsCount(this.formId)
    }
  },

  methods: {
    ...mapActions("forms", ["fetchSubmissionsCount"]),

    showFormSubmissions() {
      this.$router.push(FORM_SUBMISSIONS_HASH)
    }
  },

  watch: {
    isAuthenticated: {
      immediate: true,
      handler: function() {
        if (this.isAuthenticated) {
          this.isLoading = true

          this.fetchSubmissionsCount(this.formId).then(() => {
            this.isLoading = false
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.toolbar-submissions-button {
  overflow: initial !important;
}

.toolbar-submissions-button__count {
  font-size: 11px;
  height: 18px;
  width: 18px;
  line-height: 18px;
  position: absolute;
  top: 0;
  right: 0;
  background-color: var(--primary-brand-color-hex);
  border-radius: 50%;
  color: $color-ui--white;
}
</style>
